import React from 'react';
import { GameHolder } from '../gameHolder';
import LiveTickets from '../liveTickets';
import UserBalance from '../userBalance';
import GameLogo from '../gameLogo';
import IconFairnessMobile from '../iconFairnessMobile';
import MobileGame from '../mobileGame';
import { DemoButton } from '../demoButton/demoButton';

function MobileGameContent({ isDemo, isTestPlatform, hasRealModeSwitcher }) {
  return (
    <>
      <GameHolder>
        <MobileGame />
      </GameHolder>
      <div className='keno-balance-row'>
        <div className='keno-balance-wrapper'>
          <div className='keno-balance-content'>
            <IconFairnessMobile />
            <GameLogo />
            <div className='keno-betslip-rgt'>
              <UserBalance />
              <div className='keno-open-menu-btn' />
            </div>
            {isDemo && !isTestPlatform && !hasRealModeSwitcher && <DemoButton />}
          </div>
        </div>
      </div>
      <LiveTickets />
    </>
  );
}

export default MobileGameContent;
